import React from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db, firebase } from "firebase/fbConfig.js"
import moment from 'moment'

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ProfilePicUpload from "components/CustomUpload/profilePicUpload"
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";
import { Grid } from "@material-ui/core";

// Forms
import ConfirmForm from "components/Forms/ConfirmForm.jsx"

// Assets
import DefaultProfile from "assets/img/default-avatar.png"

// Firebase Redux Integration
import { tableToFirestoreObjects, updateFirestoreWithOneObject, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetActionsList, startToggleCompleted, setUserScore } from "store/actions/actionsActions"
import { startSetUsersList } from "store/actions/adminActions"
import { startSetConfirmedOrdersList } from "store/actions/ordersActions"

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Principles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      updateProfileModal: false,
      updateConfirmhModal: false,
      updatePhotoModal: false,
      learnDashboardModal: false,
      revenue: null,
      expenses: null,
      contribution: null,
      contributionPercent: null
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.dataLoaded && !prevState.dataLoaded) {
      db.collection("haney-orders").where("groups", "array-contains-any", this.props.groups).orderBy("freightBillNumber", "desc").get()
        .then(snapshot => {
          const allOrders = snapshot.docs.map(doc => {
            const docData = doc.data();
            const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
            const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
            const cmTotal = (revenue - expenses).toFixed(2);
            const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
            return {
              id: doc.id,
              totalExpenses:"$" + this.commaFy(expenses),
              totalRevenue: "$" + this.commaFy(revenue),
              cmTotal: "$" + this.commaFy(cmTotal),
              cmPercent,
              referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key].referenceID ? docData[key].referenceID : "").filter(Boolean).join(', '),
              billingParty: docData.billingParty ? docData.billingParty : "",
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              originBusinessName: docData.origin.businessName ? docData.origin.businessName : "",
              originCity: (docData.origin.city && docData.origin.state) ? docData.origin.city + ", " + docData.origin.state : "",
              originState: docData.originState ? docData.originState : "",
              destinationBusinessName: docData.destination.businessName ? docData.destination.businessName : "",
              destinationCity: (docData.destination.city && docData.destination.state) ? docData.destination.city + ", " + docData.destination.state : "",
              destinationState: docData.destinationState ? docData.destinationState : "",
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.origin.date ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.destination.date ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              status: docData.status ? docData.status : "N/A",
              entityIDs: docData.entityIDs ? docData.entityIDs : [],
              vendorName: (docData.vendorPickUp && docData.vendorPickUp.name) ? docData.vendorPickUp.name : "N/A",
              driverName: (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A",
              signingURLs: docData.signingURLs,
              financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
              pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
              dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
              updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
              serviceETA: docData.serviceETA ? moment(docData.serviceETA.toDate()).format('MM/DD/YYYY') : "N/A",
              test: docData.test,
              actions: (
                <Link to={{
                  pathname: `/order/${doc.id}`,
                  state: {
                    shipperID: doc.id,
                    status: docData.status
                  }
                }}>
                  <Button
                    color="primary"
                    fullWidth
                  >EDIT</Button>
                </Link>
              )
            }
          }).filter(doc => !doc.test && ["completed", "delivered", "Delivered", "confirmed", "Arrived at Destination"].includes(doc.status))

          this.setState({ allOrders }, this.getFinanceData);
        })
        .catch(console.error);
    }

  }
  
  commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  getFinanceData = () => {
    const filteredTable = this.tableNode.getResolvedState().sortedData;
    console.log(filteredTable);
    const remCommas = dollarValue => dollarValue.replace(/\$|,/g, '')
    let revenue = 0;
    let expenses = 0;

    for (let i = 0; i < filteredTable.length; i++) {
      revenue += parseFloat(filteredTable[i].totalRevenue ? remCommas(filteredTable[i].totalRevenue) : 0);
      expenses += parseFloat(filteredTable[i].totalExpenses ? remCommas(filteredTable[i].totalExpenses) : 0);
    }

    revenue = revenue.toFixed(2);
    expenses = expenses.toFixed(2);
    let contribution = (revenue - expenses).toFixed(2);
    let contributionPercent = ((contribution / revenue) * 100).toFixed(2);

    this.setState({
      revenue: this.commaFy(revenue),
      expenses: this.commaFy(expenses),
      contribution: this.commaFy(contribution),
      contributionPercent
    })
  }

  handleClickOpen = (modal, ID, status) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
      ID,
      status
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  loadData = (uid) => {
    let ordersData = this.props.orders.dataRows.map((prop, key) => {
      let colObj = { ...prop }
      const ID = colObj.id
      const status = colObj.status
      // const volUID = colObj.volUID
      // const username = colObj.username
      // Load Data for Summary Cards and add buttons     
      //console.log(colObj)
      //if (colObj.uid === uid ) {
      return {
        ...colObj,
        // status: (<span style={{ color: "red" }}>assigned</span>),
        //id: key,
        actions: (
          <Button
            color="primary"
            fullWidth
            onClick={
              () => this.handleClickOpen("updateConfirmhModal",
                ID,
                status,
              )}
          >EDIT</Button>)
      }
      //} 
    })

    this.setState({
      ordersData,
      dataLoaded: true
    }, this.getFinanceData);
  }

  // Load data for Table
  // if there are no actions make a default one



  render() {
    const { AuthBool, classes, authUser, user, orders, assessments } = this.props;
    //console.log(this.state.practicesData)


    console.log(this.state)

    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? (String(row[id]).toLowerCase()).includes(filter.value.toLowerCase())
        : true;
    }

    if (orders) {
      //console.log(assessments.dataLoaded)
      if (orders.dataLoaded
        && !this.state.dataLoaded) {
        //console.log(authUser.uid)
        this.loadData(authUser.uid)
        // console.log(user)
        // console.log(user.levelUpdatedAt.toDate())
        // console.log(moment(user.levelUpdatedAt.toDate()).format('MM-DD-YYYY'))  
      }
    }

    return (
      <div>

        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            {this.state.dataLoaded ? (
              <div>
                <GridContainer >
                  {/*<GridItem xs={12} sm={12} md={6}>
                                 } <div className={classes.dashboardModalBtn}>
                    <Button
                      color="primary"
                      onClick={() => this.handleClickOpen("learnDashboardModal")}
                    >
                      LEARN ABOUT DASHBOARD
                </Button>
            </div>
                </GridItem>*/}
                </GridContainer>
                <GridContainer>

                  <GridItem xs={12} sm={12} md={12}>
                    <br />
                    <br />

                  </GridItem>
                </GridContainer>
                <hr></hr>

                <GridContainer justify='center'>
                  <GridItem xs={6} sm={3}>
                    <GridContainer justify='center'>
                      <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                          Filtered Revenue
                        </h5>
                      </GridItem>
                      <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'limegreen' }}>
                          $ {this.state.revenue}
                        </p>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                  <GridItem xs={6} sm={3}>
                    <GridContainer justify='center'>
                      <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                          Filtered Expenses
                        </h5>
                      </GridItem>
                      <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'red' }}>
                          $ {this.state.expenses}
                        </p>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                  <GridItem xs={6} sm={3}>
                    <GridContainer justify='center'>
                      <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                          Filtered Contribution
                        </h5>
                      </GridItem>
                      <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'limegreen' }}>
                          $ {this.state.contribution}
                        </p>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                  <GridItem xs={6} sm={3}>
                    <GridContainer justify='center'>
                      <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                          Filtered Contribution Percent
                        </h5>
                      </GridItem>
                      <GridItem xs={12}>
                        <p style={{ textAlign: 'center' }}>
                          {this.state.contributionPercent} %
                        </p>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>

                <ReactTable
                  ref={r => this.tableNode = r}
                  data={this.state.allOrders ? this.state.allOrders : this.state.ordersData}
                  filterable
                  defaultFilterMethod={filterCaseInsensitive}
                  columns={this.props.orders.columns}
                  defaultPageSize={50}
                  defaultSorted={[
                    {
                    }
                  ]}
                  //showPaginationTop
                  onFilteredChange={this.getFinanceData}
                  showPaginationBottom
                  style={{
                    color: "#FFF"
                  }}
                  className="-striped -highlight"
                />

                {/* UPDATE ACTION MODAL */}
                <Dialog
                  classes={{
                    root: classes.modalRoot,
                    paper: classes.modal + " " + classes.modalLarge
                  }}
                  open={this.state.updateConfirmhModal}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => this.handleClose("updateConfirmhModal")}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogTitle
                    id="shipment-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                  >
                    <Button
                      simple
                      className={classes.modalCloseButton}
                      key="close"
                      aria-label="Close"
                      onClick={() => this.handleClose("updateConfirmhModal")}
                    >
                      {" "}
                      <Close className={classes.modalClose} />
                    </Button>
                    <h2 className={classes.modalTitle}>CONFIRM ORDER: {this.state.editActionTitle}</h2>
                  </DialogTitle>
                  <DialogContent
                    id="shipment-modal-slide-description"
                    className={classes.modalBody}
                  >
                    <ConfirmForm
                      UID={this.state.UID}
                      orderID={this.state.ID}
                      modalClose={!this.state.updateConfirmhModal}
                    />
                    <Button
                      className={classes.ltrButtonWhite}
                      style={{
                        marginLeft: "10px",
                        marginTop: "10px"
                      }}
                      key="close"
                      aria-label="Close"
                      onClick={() => this.handleClose("updateConfirmhModal")}
                    >
                      CLOSE
                    </Button>
                  </DialogContent>
                </Dialog>

              </div>
            ) : (
              <p className={classes.body}>Loading...</p>
            )}
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log(state)
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    assessments: state.assessment,
    orders: state.orders.confirmedOrders
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  //console.log(state)
  return {
    startSetConfirmedOrdersList: dispatch(startSetConfirmedOrdersList(ownProps.groups))
  }
}


// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUserScore: (score) => dispatch(setUserScore(score))
//   }
// }

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(Principles);



// WEBPACK FOOTER //
// ./src/views/Dispatch/ConfirmedOrders.jsx